import React, {
    useEffect,
    useState
} from 'react';

import {
    useCustomDispatch,
    useCustomLocation,
    useCustomNavigate
} from '../hooks';

import { useAuthSelector } from '../services/selectors/authSelector';
import { verifyDriverOTP } from '../services/apis/auth/verifyOtp';

import { Loader } from '../components/common/loader';
import { removeValidateOTPData } from '../services/slices/auth/verifyOtp';
import { authToken } from '../storage/authToken';

import { getDefaultPharmacist } from '../utils/helper/helper';
import { useSuperVisorSelector } from '../services/selectors/allSuperVisorSelector';
import { PharmacistsList } from '../components/common/pharmacistsList';

import Cookies from "js-cookie";
import { getCookieOptions } from '../utils/helper/security';
import { isDevelopmentPatientMaskMode, maskHeaderText } from '../utils/helper/patientMasking';
import { normalizeBackendAssetUrl } from '../utils/helper/url';
import fallbackAvatar from '../assets/images/userimg.png';
import * as Common from '../components/common';
import * as routeNames from '../routes/routeName'

const DriverOtpVerification = () => {

    const token = authToken()

    const dispatch = useCustomDispatch()
    const navigate = useCustomNavigate()
    const location = useCustomLocation()

    const validateOtpScreen = location.pathname === routeNames.verify_otp

    const { driverSelectedPharmacy,
        driverOTPVerificationResponse,
        pharmacyId,
        driverDefaultPharmacist,
        flexiUser,
        hcpUser
    } = useAuthSelector()

    const { loading, error } = driverOTPVerificationResponse
    const { allPharmacistListResponse } = useSuperVisorSelector()

    const [otp, setOtp] = useState('');
    const [defaultPharmacist, setDefaultPharmacist] = useState(null)
    const [openPharmacistModal, setOpenPharmacistModal] = useState(false)
    const pharmacistUser = defaultPharmacist?.[0]?.driver_pharmacist_user
    const forcedPharmacistId = pharmacistUser?.id ?? null
    const hidePharmacistSelection = pharmacistUser?.type === 'pharmacist'
    const pharmacyLogo = normalizeBackendAssetUrl(driverSelectedPharmacy?.pharmacies?.logo_thumb_full_url);
    const shouldMaskPharmacy = isDevelopmentPatientMaskMode();
    const displayPharmacyName = shouldMaskPharmacy
        ? maskHeaderText(driverSelectedPharmacy?.pharmacies?.name)
        : driverSelectedPharmacy?.pharmacies?.name?.toUpperCase();

    const handleSubmit = () => {
        const reqData = {
            pharmacy_id: pharmacyId,
            otp: otp,
            dispatch: dispatch
        }
        if (pharmacyId && otp) dispatch(verifyDriverOTP({
            reqData,
            navigate,
            dispatch,
            setOpenPharmacistModal,
            setDefaultPharmacist,
            defaultPharmacist,
            flexiUser,
            hcpUser
        }))
    }

    useEffect(() => {
        if (token && pharmacyId && validateOtpScreen) {
            Cookies.set('verified', 0, getCookieOptions())
            dispatch(removeValidateOTPData())
        }
    }, [token, pharmacyId, dispatch, validateOtpScreen])

    useEffect(() => {
        const matchedPharmacies = getDefaultPharmacist(pharmacyId, driverDefaultPharmacist);
        setDefaultPharmacist(matchedPharmacies)
    }, [pharmacyId, driverDefaultPharmacist])

    return (
        <>
            <div className="app-wrapper flex items-center justify-center ">
                <div className="app-screen no-shades w-full xl:w-3/12 lg:w-4/12 md:w-5/12 sm:w-6/12 h-full flex flex-col overflow-x-hidden">
                    <div className="relative p-4 w-full">
                        <Common.Header />

                        <div className='text-center'>
                            <div className="flex items-center gap-3 justify-center mt-20">
                                <div className="rounded-md flex items-center justify-center"
                                    style={{ width: '80px', height: '80px' }}>
                                    <img
                                        className='rounded-lg'
                                        style={{ width: '80px', height: '80px' }}
                                        src={pharmacyLogo}
                                        alt=''
                                        onError={(event) => {
                                            event.currentTarget.src = fallbackAvatar;
                                        }}
                                    />
                                </div>

                            </div>
                            <h1 className="text-md font-bold mt-2">
                                {displayPharmacyName}</h1>
                        </div>

                        <div className="relative  mt-4 flex justify-center">
                            <input
                                key={'otp'}
                                type="text"
                                maxLength="6"
                                value={otp.slice(0, 6)}
                                inputMode="numeric"
                                placeholder='Enter OTP'
                                onChange={(e) => setOtp(e.target.value)}
                                className={`w-full ${(error?.data?.message || error?.data?.data?.error?.[0]) && 'border border-red-600'}  border border-gray-300 text-gray-500 rounded-md text-xl focus:ring-2 focus:ring-blue-300`}
                            />
                        </div>

                        {(error?.data?.message || error?.data?.data?.error?.[0]) && (
                            <p className='text-red-600'>
                                {error?.data?.message === 'Invalid Otp'
                                    ? 'Invalid OTP'
                                    : error?.data?.message === 'Expired Otp'
                                        ? 'The OTP has expired.'
                                        : (error?.data?.data?.error?.[0] || error?.data?.message)}
                            </p>
                        )}

                        <div className="relative mt-4">
                            <button
                                type="button"
                                onClick={handleSubmit}
                                className={`text-white flex items-center justify-center w-full focus:ring-4 focus:ring-blue-300 font-bold bg-blue-700 rounded-lg text-lg px-5 py-3 me-2 mb-2 
                                ${otp?.length !== 6 ? 'opacity-50 pointer-events-none' : ''}`}>
                                {loading ? <Loader /> : 'Verify OTP'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <PharmacistsList showPharmacistModal={openPharmacistModal}
                allPharmacistListResponse={allPharmacistListResponse}
                defaultPharmacist={defaultPharmacist}
                pharmacyId={pharmacyId}
                driverSelectedPharmacy={driverSelectedPharmacy}
                setShowPharmacistModal={setOpenPharmacistModal}
                forcedPharmacistId={forcedPharmacistId}
                hidePharmacistSelection={hidePharmacistSelection}
                flexiUser={flexiUser}
                hcpUser={hcpUser}
            />

        </>
    );
}

export default DriverOtpVerification;
